import { render, staticRenderFns } from "./regionCity.vue?vue&type=template&id=e4e95d0c"
import script from "./regionCity.vue?vue&type=script&lang=js"
export * from "./regionCity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports